import React, { useEffect, useReducer, useState } from "react";
import { Box, Container, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import CustomBreadcrumbs from "../../../components/breadcrumbs";

import PhotoSizeSelectLargeIcon from '@mui/icons-material/PhotoSizeSelectLarge';
import { GetForAdd, UpdateProduct } from "../../../controllers/company/ProductsController";
import { useHistory } from "react-router-dom";
import ModalDialog from "../../../components/modalDialog";
import { imagesURL } from "../../../apiRoutes/apiBase";
import QUDProgress from "../../../components/progress";
import ResponseComponent from "../../../components/responseComponent";
import { Dropzone, FileMosaic, FullScreen, ImagePreview } from "@files-ui/react";
import ReactQuill from "react-quill";






//DECLARAMOS LOS ESTADOS INICIALES
const initialState = {

    unidades:[],
    categorias:[],

    idProducto:'',
    nombre : '',          errorNombre : false,
    errorDescripcion : false,
    idUnidad : '',        errorIdUnidad : false,
    idSubCategoria : '',  errorIdSubCategoria : false,
    suscripcion: '0',
    facturacion: '',      errorFacturacion: false,
    precio : '',          errorPrecio : false,
    estatus : '',         errorEstatus : false,
    
    
    isLoading : false,

    open: false,
    title: '',
    message: '',
    success: false
  }
  
  function reducer( state, { field, value })
  {
    return{
        ...state,
        [field] : value
    }
  }

  


export default function ProductUpdate()
{
    const [state,setState] = useReducer(reducer,initialState);
    const [rutaImg,setRutaImg] = useState('');
    const [img,setImg] = useState([]);

    const [coverUrl,setCoverUrl] = useState('');
    const [coverFile,setCoverFile] = useState([]);

    const [imgPreviewSrc, setImgPreviewSrc] = useState(undefined);

    const [descripcion,setDescripcion] = useState('');

    const {
        unidades, categorias, idProducto,
        nombre, errorNombre, errorDescripcion,
        idUnidad, errorIdUnidad, idSubCategoria, errorIdSubCategoria,
        precio, errorPrecio, estatus, errorEstatus,
        suscripcion, facturacion, errorFacturacion,

        isLoading,
        open,
        title,
        message,
        success

    } = state;

    useEffect(()=>{
        window.scrollTo(0,0);
        getForAdd();
        setProduct();
    },[]);

    const history = useHistory();

    const setProduct = () => {
        let producto = JSON.parse(localStorage.getItem('producto'));
        setRutaImg(imagesURL+'productos/'+producto.imagen);
        setState({field:'idProducto',value:producto.idProducto});
        setState({field:'nombre',value:producto.producto});
        
        setState({field:'idUnidad',value:producto.idUnidad});
        setState({field:'idSubCategoria',value:producto.idSubCategoria});
        setState({field:'suscripcion',value:producto.s1});
        setState({field:'facturacion',value:producto.facturacion});
        setState({field:'precio',value:producto.precioUSD});
        setState({field:'estatus',value:producto.e1});

        setCoverUrl(imagesURL+'productos/'+producto.imagen);
        setDescripcion(producto.descripcion);
    }


    const getForAdd = async () => {
        let response = await GetForAdd();
        if(response.success === true)
        {
            setState({field:'unidades',value:response.data.unidades});
            setState({field:'categorias',value:response.data.categorias});
        }
    }

    
    const handleImagen = async (event) =>
    {
        await setImg(event.target.files[0]);
        await setRutaImg(URL.createObjectURL(event.target.files[0]));
    }

    
    const onChange = (e) => {
        setState({field : e.target.name, value : e.target.value});
    }


    const formVerification = () => {
        var ban = 0;

        if(nombre === '')
        {
            setState({field:'errorNombre',value:true});
            ban = 1;
        }

        if(descripcion === '')
        {
            setState({field:'errorDescripcion',value:true});
            ban = 1;
        }
        
            
        if(idUnidad === '')
        {
            setState({field:'errorIdUnidad',value:true});
            ban = 1;
        }

        if(idSubCategoria === '')
        {
            setState({field:'errorIdSubCategoria',value:true});
            ban = 1;
        }

        if(precio === '')
        {
            setState({field:'errorPrecio',value:true});
            ban = 1;
        }

        if(estatus === '')
        {
            setState({field:'errorEstatus',value:true});
            ban = 1;
        }

        if(suscripcion === '1' && facturacion === '')
        {
            setState({field:'errorFacturacion',value:true});
            ban = 1;
        }
        else
        {
            setState({field:'errorFacturacion',value:false});
        }

        
        
        return ban;
    }
    
    
    const handleAddProduct = async () => {
        setState({field:'isLoading',value:true});
        if(formVerification() === 0)
        {
            let response = await UpdateProduct(idProducto,nombre,descripcion,idUnidad,idSubCategoria,precio,estatus,img,suscripcion,facturacion);
            if(response.success === true)
            {
                setState({field:'title',value:response.message.title});
                setState({field:'message',value:response.message.message});
                setState({field:'success',value:true});
                setState({field:'open',value:true});
            }
            else
            {
                setState({field:'title',value:response.message.title});
                setState({field:'message',value:response.message.message});
                setState({field:'success',value:false});
                setState({field:'open',value:true});
            }
        }
        setState({field:'isLoading',value:true});
    }

    const clear = () => {
        setState({field:'nombre',value:''}); setState({field:'errorNombre',value:false});
        setState({field:'descripcion',value:''}); setState({field:'errorDescripcion',value:false});
        setState({field:'idUnidad',value:''}); setState({field:'errorIdUnidad',value:false});
        setState({field:'idSubCategoria',value:''}); setState({field:'errorIdSubCategoria',value:false});
        setState({field:'precio',value:''}); setState({field:'errorPrecio',value:false});
        setState({field:'estatus',value:''}); setState({field:'errorEstatus',value:false});

        setState({field:'suscripcion',value:'0'}); setState({field:'facturacion',value:''});

        setRutaImg(''); setImg([]);

        setState({field:'open',value:false});
    }

    const handleClose = () => {
        if(success === true)
            history.push('/products');
        else
            setState({field:'open',value:'false'});
    }


    const updateCoverFile = async (incommingFiles) => {
        //do something with the files
        setCoverFile(incommingFiles);

        //even your own upload implementation        
        //UpdateImagen('imagenFondo',incommingFiles[0].file);
    };
    const removeCoverFile = (id) => {
        setCoverFile(coverFile.filter((x) => x.id !== id));
    };

     const handleSee = (imageSource) => {
        setImgPreviewSrc(imageSource);
    };



    return(
        <Container>
            <CustomBreadcrumbs
                returnTo='/products'
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Actualizar',link:'/products/update'}
                ]}
            />
            <br/>

            {/**Nueva version - V2 */}
            <Grid container spacing={3} sx={{mt:5,mb:5}}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="h4" component="h1">
                        Actualizar producto
                    </Typography>
                </Grid>
                
                {/**Nombre */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField
                        fullWidth
                        label='Nombre'
                        name='nombre'
                        id='nombre'
                        required
                        value={nombre}
                        onChange = { onChange }
                        onBlur={ () => (nombre === '' ? setState({field:'errorNombre',value:true}) : setState({field:'errorNombre',value:false}) ) }
                        error = {errorNombre}
                        helperText={errorNombre && 'Ingrese el nombre del producto'}
                    />
                </Grid>

                {/**Categorias */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField
                        fullWidth
                        select
                        id="idSubCategoria"
                        name='idSubCategoria'
                        label="Categoría"
                        variant="outlined"
                        value = {idSubCategoria}
                        onChange = { onChange }
                        onBlur={ () => (idSubCategoria === '' ? setState({field:'errorIdSubCategoria',value:true}) : setState({field:'errorIdSubCategoria',value:false}) ) }
                        error = {errorIdSubCategoria}
                        helperText={errorIdSubCategoria && 'Seleccione la categoría'}
                    >
                        <MenuItem value=''>Seleccione una Categoría</MenuItem>
                        {
                            categorias.length !== 0 &&
                            categorias.map((item)=>
                                <MenuItem value={item.idSubCategoria}>{item.nombre}</MenuItem>
                            )
                        }
                    </TextField>
                </Grid>

                {/**Imagen */}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="h6">Foto del producto</Typography>
                    <Typography variant="body1">Se recomienda una imagen cuadrada ejemplo 1024*1024 px</Typography>
                    {/**Imagen de portada */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Dropzone
                            onChange={updateCoverFile}
                            label="Imagen de portada"
                            value={coverFile}
                            accept="image/*"
                            maxFileSize={512 * 1024}
                            maxFiles={1}
                            behaviour="replace"
                            cleanFiles
                            actionButtons={{ position: "bottom", cleanButton: {} }}
                            localization="ES-es"
                        >
                            {
                                coverFile.length > 0 
                                ?
                                    coverFile.map((file) => (
                                        <Box sx={{width:{xs:150,sm:200,md:200,lg:250,xl:250}, height:{xs:150,sm:200,md:200,lg:250,xl:250},p:2}}>
                                            <FileMosaic style={{width:'100%',height:'100%'}} {...file} preview  />
                                        </Box>
                                    ))
                                :
                                    <Box sx={{width:{xs:150,sm:200,md:200,lg:250,xl:250}, height:{xs:150,sm:200,md:200,lg:250,xl:250},p:2}}>
                                        <img style={{width:'100%',height:'100%'}} src={coverUrl} alt={'QUD'}/>
                                    </Box>
                            }
                        </Dropzone>
                    </Grid>
                </Grid>

                {/**Descripcion */}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={5}>
                    <Typography fontWeight={'bold'}>Descripción</Typography>
                    <Typography fontStyle={'italic'}>Ingresa la descripción del producto</Typography>
                    <ReactQuill
                        theme="snow"
                        placeholder="Describe aquí tu producto o servicio. Incluye los detalles clave y los beneficios que lo hacen especial para ayudar a tus clientes a tomar la mejor decisión."
                        id="descripcion"
                        name="descripcion"
                        value={descripcion}
                        onChange={setDescripcion}
                        onBlur={()=>setState({field:'errorDescripcion',value:descripcion===''?true:false})}
                        //onBlur={ () => (descripcion === '' ? setState({field:'errorDescripcion',value:true}) : setState({field:'errorDescripcion',value:false}) ) }

                        style={{height:300}}
                    />
                    {
                        errorDescripcion &&
                        <Typography color={'error.main'} mt={5}>Ingresa la descripción del producto</Typography>
                    }
                </Grid>

                {/**Unidad de medida */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField
                        fullWidth
                        select
                        id="idUnidad"
                        name='idUnidad'
                        label="Unidad de medida"
                        variant="outlined"
                        value = {idUnidad}
                        onChange = { onChange }
                        onBlur={ () => (idUnidad === '' ? setState({field:'errorIdUnidad',value:true}) : setState({field:'errorIdUnidad',value:false}) ) }
                        error = {errorIdUnidad}
                        helperText={errorIdUnidad && 'Seleccione la unidad de medida'}
                    >
                        <MenuItem value=''>Seleccione una unidad</MenuItem>
                        {
                            unidades.length !== 0 &&
                            unidades.map((item)=>
                                <MenuItem value={item.idUnidad}>{item.nombre}</MenuItem>
                            )
                        }
                    </TextField>
                </Grid>

                {/**Suscripcion */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField
                        fullWidth
                        select
                        id="suscripcion"
                        name='suscripcion'
                        label="Se comercializa como suscripción"
                        variant="outlined"
                        value = {suscripcion}
                        onChange = { onChange }
                    >
                        <MenuItem value='0'>No</MenuItem>
                        <MenuItem value='1'>Si</MenuItem>
                    </TextField>
                </Grid>

                {/**Periodo de facturacion */}
                {
                    suscripcion === '1' &&
                    
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <TextField
                            fullWidth
                            select
                            id="facturacion"
                            name='facturacion'
                            label="Periodo de facturación"
                            variant="outlined"
                            value = {facturacion}
                            onChange = { onChange }

                            onBlur={ () => ((suscripcion === '1' && facturacion === '') ? setState({field:'errorFacturacion',value:true}) : setState({field:'errorFacturacion',value:false}) ) }
                            error = {errorFacturacion}
                            helperText={errorFacturacion && 'Seleccione el periodo de facturación'}
                        >
                            <MenuItem value=''>Seleccione el periodo de facturación</MenuItem>
                            <MenuItem value='semanal'>Semanal</MenuItem>
                            <MenuItem value='quincenal'>Quincenal</MenuItem>
                            <MenuItem value='mensual'>Mensual</MenuItem>
                            <MenuItem value='trimestral'>Trimestral</MenuItem>
                            <MenuItem value='semestral'>Semestral</MenuItem>
                            <MenuItem value='anual'>Anual</MenuItem>
                        </TextField>
                    </Grid>
                }

                {/**Precio */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField
                        fullWidth
                        label='Precio $'
                        name='precio'
                        id='precio'
                        required
                        value={precio}
                        onChange = { onChange }
                        onBlur={ () => (precio === '' ? setState({field:'errorPrecio',value:true}) : setState({field:'errorPrecio',value:false}) ) }
                        error = {errorPrecio}
                        helperText={errorPrecio && 'Ingrese el precio del producto'}
                    />
                </Grid>
                {/**Estatus */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField
                        fullWidth
                        select
                        id="estatus"
                        name='estatus'
                        label="estatus"
                        variant="outlined"
                        value = {estatus}
                        onChange = { onChange }
                        onBlur={ () => (estatus === '' ? setState({field:'errorEstatus',value:true}) : setState({field:'errorEstatus',value:false}) ) }
                        error = {errorEstatus}
                        helperText={errorEstatus && 'Seleccione el estatus'}
                    >
                        <MenuItem value=''>Seleccione un estatus</MenuItem>
                        <MenuItem value='1'>Activo</MenuItem>
                        <MenuItem value='0'>Inactivo</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                    <LoadingButton
                        fullWidth
                        variant="contained"
                        onClick={()=>handleAddProduct()}
                    >
                        <Typography>
                            Actualizar producto
                        </Typography>
                    </LoadingButton>
                </Grid>

            </Grid>

            
            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Si'}
                onClick={()=>handleClose()}
            />

            <FullScreen
                open={imgPreviewSrc !== undefined}
                onClose={() => setImgPreviewSrc(undefined)}
            >
                <ImagePreview src={imgPreviewSrc} />
            </FullScreen>
            
        </Container>
    )
}